import _toConsumableArray from "@babel/runtime-corejs3/helpers/esm/toConsumableArray";
import _objectWithoutProperties from "@babel/runtime-corejs3/helpers/esm/objectWithoutProperties";
var _excluded = ["disabled"];
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js-stable/instance/concat";
import _Object$values from "@babel/runtime-corejs3/core-js-stable/object/values";
import { useRef, useEffect } from 'react';
import { glowHoverEffect } from './glow-hover-effect.js';

var useGlowHover = function useGlowHover(_ref) {
  var _context;

  var _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      options = _objectWithoutProperties(_ref, _excluded);

  var ref = useRef(null);
  useEffect(function () {
    return !disabled && ref.current ? glowHoverEffect(ref.current, options) : // eslint-disable-next-line @typescript-eslint/no-empty-function
    function () {};
  }, _concatInstanceProperty(_context = [disabled]).call(_context, _toConsumableArray(_Object$values(options))));
  return ref;
};

export { useGlowHover };
